<div class="page-not-found">
    <img class="sademoji" src="../../assets/images/sadEmoji.svg" alt="image not found" />
    <p class="text-white display-4 notFound">Page not found</p>
    <p class="downText">
        The page you are looking for was not found
    </p>
    <button  class="btn btn-primary goHome" (click)="navigateTogetStarted()"> Go Home</button>
</div>